<template>
  <div>
    <div class="card-header">
      <h2 class="card-title">Documents</h2>
      <div>
        <button
          class="btn btn-primary"
          v-on:click.prevent="openGenerateDocumentModal"
          v-if="!rejected && !readonly && hasPermission('documents.create')"
        >
          Generate Document
        </button>
        <button
          class="btn btn-primary"
          v-on:click.prevent="openAddDocumentModal"
          v-if="!readonly && hasPermission('documents.create')"
        >
          Add Document
        </button>
      </div>
    </div>

    <div class="card-header">
      <div style="width: 100%; margin: 0;">
        <label for="handler_id" style="margin-top: 0;">Handler</label>

        <select
          name="handler_id"
          id="handler_id"
          class="form-control"
          :value="filters.type_id"
          @change="setType($event.target.value)"
        >
          <option value="">All Types</option>
          <option :key="index" :value="type.id" v-for="(type, index) in types">
            {{ type.label }}
          </option>
        </select>
      </div>
    </div>

    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Document Type</th>
          <th>Document Description</th>
          <th>Uploaded</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="index" v-for="(document, index) in documents">
          <td>{{ document.type ? document.type.label : 'Not Provided' }}</td>
          <td>{{ document.description }}</td>
          <td>{{ document.created_at }}</td>
          <td>
            <button
              type="button"
              class="btn btn-primary"
              v-on:click.prevent="viewDocument(document)"
            >
              View
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-on:click.prevent="openEditDocumentModal(document)"
              v-if="!readonly && hasPermission('claims.update')"
            >
              Edit
            </button>
            <button
              type="button"
              class="btn btn-danger"
              v-on:click.prevent="deleteDocument(document)"
              v-if="!readonly && hasPermission('documents.delete')"
            >
              Delete Document
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <add-document
      :incident="incident"
      :show="modals.add"
      :rejected="rejected"
      v-on:close="closeAddDocumentModal"
      v-on:added="refresh"
      :types="types"
    ></add-document>

    <edit-document
      :incident="incident"
      :document="selectedDocument"
      :show="modals.edit"
      v-on:close="closeEditDocumentModal"
      v-on:edited="refresh"
      :types="types"
    ></edit-document>

    <generate-document
      :incident="incident"
      :show="modals.generate"
      v-on:close="closeGenerateDocumentModal"
      v-on:generated="refresh"
      :types="types"
    ></generate-document>
  </div>
</template>
<script>
import AddDocument from './Children/AddDocument.vue';
import EditDocument from './Children/EditDocument.vue';
import GenerateDocument from './Children/GenerateDocument.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    rejected: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AddDocument,
    EditDocument,
    GenerateDocument
  },

  data() {
    return {
      modals: {
        add: false,
        edit: false,
        generate: false
      },
      documents: [],
      filters: {
        type_id: ''
      },
      selectedDocument: null
    };
  },

  computed: {
    types() {
      return this.$store.getters['DocumentTypes/all'] || [];
    }
  },

  mounted() {
    this.getDocuments();

    this.$store.commit('DocumentTypes/retrieve');
  },

  methods: {
    getDocuments() {
      window.Ajax.get(
        `/incidents/${this.incident}/documents?filter[type_id]=${
          this.filters.type_id
        }${this.rejected ? '&filter[status]=rejected' : ''}`
      )
        .then(response => {
          this.documents = response.data;
        })
        .catch(error => {});
    },

    refresh() {
      this.modals.add = false;
      this.modals.edit = false;
      this.selectedDocument = null;
      this.modals.generate = false;
      this.getDocuments();
      window.toastify.success(
        'Success!',
        'The document was uploaded successfully!'
      );
    },

    closeAddDocumentModal() {
      this.modals.add = false;
    },

    closeEditDocumentModal() {
      this.modals.edit = false;
      this.selectedDocument = null;
    },

    openAddDocumentModal() {
      this.modals.add = true;
    },

    openEditDocumentModal(document) {
      this.selectedDocument = document;
      this.modals.edit = true;
    },

    closeGenerateDocumentModal() {
      this.modals.generate = false;
    },

    openGenerateDocumentModal() {
      this.modals.generate = true;
    },

    deleteDocument(document) {
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will permanently remove the document',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.delete(
            `/incidents/${this.incident}/documents/${document.identifier}${
              this.rejected ? '?filter[status]=rejected' : ''
            }`
          )
            .then(response => {
              window.toastify.success('Deleted', 'The document was deleted!');

              let found = this.documents.findIndex(record => {
                return record.identifier === document.identifier;
              });

              if (found > -1) {
                this.documents.splice(found, 1);
              }
            })
            .catch(error => {});
        });
    },

    viewDocument(document) {
      window.open(document.url, '_blank');
    },

    setType(type) {
      this.filters.type_id = type;

      this.getDocuments();
    }
  }
};
</script>
